export const STATUS = {
  WEIGHED: 'weighed',
  SHORT_WEIGHED: 'short_weighed',
  NO_RECORD: 'no_record'
}

export const BACKEND_REASON = {
  SHORT_WEIGHT: 'short_weight',
  ALREADY_WEIGHED: 'already_weighed',
  GROUP_NOT_FOUND: 'group_not_found',
  WITHOUT_CATERING: 'without_catering'
}

export const HTTP_STATUS = {
  UNPROCESSABLE: 422,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  CONFLICT: 409
}

export const WEIGHT_WARNING_FACTOR = 2

export const WEIGHT_BLOCK_FACTOR = 3

export const REAL_WEIGHT_INPUT_ID_PREFIX = 'real-weight-input'

export const TEXTS = {
  SCREEN_TITLE: 'Pesos Cocidos',
  DATE_PLACEHOLDER: 'Seleccionar fecha',
  LOADING: 'Cargando pesos cocidos...',
  EMPTY: 'No hay datos para esta fecha',
  SHORT_ALERT_TITLE: 'Pesaste {weight}. Este grupo debe rendir al menos el {percent} % de lo que entró crudo: {minimum} ya cocido.',
  SHORT_ALERT_TITLE_WITHOUT_YIELD: 'Pesaste {weight}. Este grupo debe rendir al menos {minimum} ya cocido.',
  SHORT_ALERT_CHECK_TITLE: '¿Pesaste bien?',
  SHORT_ALERT_CHECK_TEXT: 'Balanza en 0 con el recipiente vacío, y todo el grupo junto y ya cocido.',
  SHORT_ALERT_COOK_TITLE: 'Si pesaste bien, cocina esto en crudo y vuelve a pesar todo el grupo:',
  SHORT_ALERT_CLOSING: 'Si no puedes completar, avisa a tu supervisor antes de servir.',
  COOK_LINE: '{name}: {raw}',
  TAKE_FROM_STORE: ' (saca {gross} del almacén)',
  WEIGHED_STATUS: 'Listo',
  SHORT_STATUS: 'No llega al mínimo',
  RAW_PORTIONED_STATUS: 'Porciona en crudo',
  RAW_PORTION_COOKED: 'cocido: {grams} g o más',
  EACH_FEMININE_SUFFIX: ' cada una',
  EACH_MASCULINE_SUFFIX: ' cada uno',
  PENDING_GROUPS: 'Falta pesar: {groups}',
  REAL_WEIGHT_PLACEHOLDER: 'Ej: 4.600',
  INVALID_WEIGHT_FORMAT: 'Escribe solo números, con punto o coma. Ejemplo: 4.600',
  SAVE_WEIGHT: 'Guardar peso',
  STEP_TARE: 'Deja la balanza en 0 con el recipiente vacío.',
  STEP_WEIGH_MIX_PREFIX: 'Pesa juntos, ya cocidos, los',
  STEP_WEIGH_MIX_SUFFIX: 'insumos del grupo.',
  STEP_SPLIT_MIX: 'Si no entran en un recipiente, pésalos por partes y suma.',
  STEP_WEIGH_PREFIX: 'Pesa',
  STEP_WEIGH_SINGLE_SUFFIX: 'ya cocido.',
  STEP_WEIGH_GROUP: 'Pesa el grupo ya cocido.',
  STEP_SPLIT_SINGLE: 'Si no entra en un recipiente, pésalo por partes y suma.',
  STEP_WRITE: 'Escribe el peso y guarda.',
  WEIGHT_FORMAT_HINT: 'Con punto o coma: 4.600 = 4 kilos y 600 gramos.',
  REAL_WEIGHT_ARIA_LABEL: 'Peso del grupo en kilos',
  INGREDIENTS_TITLE: 'Crudo que se habilitó hoy',
  INGREDIENTS_HELP: 'Son los pesos en crudo limpio (sin merma) de todo el día: lo que se habilita antes de cocinar. No se comparan con el peso cocido.',
  CONFIRM_WEIGHT_QUESTION: '¿Es correcto?',
  CONFIRM_WEIGHT_YES: 'Confirmar',
  CONFIRM_WEIGHT_NO: 'Volver a escribir',
  MORE_THAN_DOUBLE_MINIMUM: 'Es más del doble del mínimo',
  IMPOSSIBLE_WEIGHT: 'Este peso no es posible, vuelve a escribirlo',
  ENTERED_WEIGHT: 'Ingresaste',
  KILOGRAMS_SUFFIX: 'kg',
  LESS_THAN_ONE_GRAM: 'menos de 1 g',
  GRAMS_SUFFIX: 'g',
  EMPTY_CELL: '—',
  KCAL_SUFFIX: 'kcal',
  TO_WEIGH_STATUS: 'Por pesar',
  NOT_SUMMING_CELL: 'No suma',
  NOT_WEIGHABLE_DESCRIPTION: 'Este grupo no suma al peso del plato. No se pesa.',
  ZERO_GROUP_SINGULAR_RULE: 'no suma al peso del plato: se agrega al servir y no se pesa.',
  ZERO_GROUP_PLURAL_RULE: 'no suman al peso del plato: se agregan al servir y no se pesan.',
  LIST_SEPARATOR: ', ',
  LIST_LAST_SEPARATOR: ' y ',
  MEAL_TOTAL_ROW: 'Total por plato',
  MEAL_TOTAL_HELP: 'Aparece cuando todos los grupos pasaron. En gris, el mínimo que pide la receta.',
  MEAL_TOTAL_SEPARATOR: ' / ',
  REGISTERED_WEIGHT_LABEL: 'Peso cocido registrado',
  LAST_ATTEMPT_WEIGHT_LABEL: 'Peso del último intento',
  MINIMUM_COOKED_LABEL: 'Mínimo cocido',
  YIELD_LINE: 'Rinde {real} %. La receta pide al menos {minimum} %.',
  WEIGHED_AT_PREFIX: 'a las',
  WEIGH_ACTION: 'Pesar',
  WEIGH_AGAIN_ACTION: 'Pesar de nuevo',
  ERROR_FALLBACK: 'No pudimos completar la acción. Intenta de nuevo.',
  ERROR_GROUP_NOT_FOUND: 'No encontramos este grupo para la fecha.',
  ERROR_WITHOUT_CATERING: 'Tu usuario no tiene una cocina asignada.',
  ERROR_ALREADY_WEIGHED: 'Este grupo ya fue pesado.'
}

export const ERROR_TEXT_BY_REASON = {
  [BACKEND_REASON.ALREADY_WEIGHED]: TEXTS.ERROR_ALREADY_WEIGHED,
  [BACKEND_REASON.GROUP_NOT_FOUND]: TEXTS.ERROR_GROUP_NOT_FOUND,
  [BACKEND_REASON.WITHOUT_CATERING]: TEXTS.ERROR_WITHOUT_CATERING
}
